




import utils from "@/utils.coffee"

export default {
    "name": "MyFlag",
    "props": {
        lang: String
    }
    "computed": {
        "getFlag": () ->
            return utils.languageMapping(@lang)
    }
}
